import React, { useMemo } from 'react'
import { ROUTES } from 'constants/routes'
import { Trans, useTranslation } from 'react-i18next'
import { NotificationsConfirm } from 'gu-ui-kit'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

const EmptyWalletNotification = ({ activeMethod, wallet }) => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()

  const wallets = useMemo(() => activeMethod?.params?.wallets ?? null, [activeMethod])

  const showNotification = useMemo(() => {
    if (activeMethod?.method !== 'user_balance') {
      return false
    }

    if (wallets.length === 0) {
      return true
    }

    return wallet?.balance !== undefined && wallet.balance === 0
  }, [wallets, activeMethod, wallet])

  return (
    showNotification && (
      <NotificationsConfirm
        variant={'notice'}
        className={'margin-bottom-16'}
        title={t('billing::form.wallet_id.notifications.empty_wallet.title')}
        CloseButton={false}
        description={
          <div>
            <Trans i18nKey={'billing::form.wallet_id.notifications.empty_wallet.description'}>
              Для пополнения рекламного аккаунта с помощью баланса getUNIQ необходимо
              <Link to={pathGen(ROUTES.BILLING_TOP_UP)}>пополнить баланс</Link>
            </Trans>
          </div>
        }
      />
    )
  )
}

export default EmptyWalletNotification

EmptyWalletNotification.propTypes = {
  activeMethod: PropTypes.object,
  wallet: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
}
